// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_kg-6";
export var emphasizeQuantity = "_kg-3";
export var flatBottomCorners = "_kg-5";
export var productImage = "_kg-0";
export var quantityContainer = "_kg-2";
export var tooltip = "_kg-1";
export var wrapAndEllipsesOverflow = "_kg-4";